/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Forward_Email_HintInputs */

const en_home_v2_forward_email_hint = /** @type {(inputs: Home_V2_Forward_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forward to your Listening inbox`)
};

const es_home_v2_forward_email_hint = /** @type {(inputs: Home_V2_Forward_Email_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenvía a tu bandeja de Listening`)
};

/**
* | output |
* | --- |
* | "Forward to your Listening inbox" |
*
* @param {Home_V2_Forward_Email_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_forward_email_hint = /** @type {((inputs?: Home_V2_Forward_Email_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Forward_Email_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_forward_email_hint(inputs)
	return en_home_v2_forward_email_hint(inputs)
});